import { SvgIcon, SvgIconProps } from "@mui/material";

export const GalleryAddIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 48 48" stroke="currentColor">
    <path
      d="M18 21.5C14.96 21.5 12.5 19.04 12.5 16C12.5 12.96 14.96 10.5 18 10.5C21.04 10.5 23.5 12.96 23.5 16C23.5 19.04 21.04 21.5 18 21.5ZM18 13.5C16.62 13.5 15.5 14.62 15.5 16C15.5 17.38 16.62 18.5 18 18.5C19.38 18.5 20.5 17.38 20.5 16C20.5 14.62 19.38 13.5 18 13.5Z"
      fill="currentColor"
    />
    <path
      d="M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H26C26.82 2.5 27.5 3.18 27.5 4C27.5 4.82 26.82 5.5 26 5.5H18C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V20C42.5 19.18 43.18 18.5 44 18.5C44.82 18.5 45.5 19.18 45.5 20V30C45.5 40.86 40.86 45.5 30 45.5Z"
      fill="currentColor"
    />
    <path
      d="M42.5 11.5H31.5C30.68 11.5 30 10.82 30 10C30 9.18 30.68 8.5 31.5 8.5H42.5C43.32 8.5 44 9.18 44 10C44 10.82 43.32 11.5 42.5 11.5Z"
      fill="currentColor"
    />
    <path
      d="M37 17C36.18 17 35.5 16.32 35.5 15.5V4.5C35.5 3.68 36.18 3 37 3C37.82 3 38.5 3.68 38.5 4.5V15.5C38.5 16.32 37.82 17 37 17Z"
      fill="currentColor"
    />
    <path
      d="M5.3401 39.4001C4.8601 39.4001 4.3801 39.1601 4.1001 38.7401C3.6401 38.0601 3.8201 37.1201 4.5001 36.6601L14.3601 30.0401C16.5201 28.6001 19.5001 28.7601 21.4601 30.4201L22.1201 31.0001C23.1201 31.8601 24.8201 31.8601 25.8001 31.0001L34.1201 23.8601C36.2601 22.0401 39.5801 22.0401 41.7201 23.8601L44.9801 26.6601C45.6001 27.2001 45.6801 28.1401 45.1401 28.7801C44.6001 29.4001 43.6601 29.4801 43.0201 28.9401L39.7601 26.1401C38.7601 25.2801 37.0601 25.2801 36.0801 26.1401L27.7601 33.2801C25.6401 35.1001 22.3001 35.1001 20.1601 33.2801L19.5001 32.7001C18.5801 31.9201 17.0601 31.8401 16.0401 32.5401L6.2001 39.1601C5.9201 39.3201 5.6201 39.4001 5.3401 39.4001Z"
      fill="currentColor"
    />
  </SvgIcon>
);
